<div class="statement">
  <div class="statement-notes service-card">
    <div class="s-card-header ">
      <span class="flex-between-start flex-column">
        {{'invoice.invoice'|translate}}
      </span>
    </div>


    <div class="s-card-body statement-service">
      <div class="s-card-row flex-start-center">
        <p class="m-0 invCode font-bold pr-2">{{'invoice.invoice'|translate}}#</p>
        <p class="m-0 paymentCode font-bold pr-2">{{'receipt-no'|translate}}#</p>
        <p class="m-0 orderName font-bold">{{'order-name'|translate}}</p>
        <p class="m-0 invoiceDate font-bold">{{'invoice-date'|translate}}</p>
        <p class="m-0 invoiceValue font-bold ">{{'invoice-value'|translate}}</p>
        <p class="m-0 payment font-bold ">{{'payment'|translate}}</p>
        <p class="m-0 oldPayment font-bold ">{{'old-payment'|translate}}</p>
        <p class="m-0 balanceDue font-bold ">{{'balance-due'|translate}}</p>
      </div>

      <div class="s-card-row flex-start-center" *ngFor="let item of statementList; let itemIndex = index">
        <p class="m-0 invCode align-self-start pr-2 font-bold">
          <a download rel="noopener noreferrer" target="_blank" class="font-blue" [href]="invoiceLinks[item?._id]">
            {{item?.invCode}}
          </a>
        </p>

        <p class="m-0 paymentCode align-self-start pr-2 font-bold">
          <a download rel="noopener noreferrer" target="_blank" class="font-blue" [href]="paymentLinks[item?._id]">
            {{item?.paymentCode}}
          </a>
        </p>

        <p class="m-0 orderName align-self-start">
          {{item?.title}}
        </p>

        <p class="m-0 invoiceDate align-self-start">
          <span>
            {{item?.invoiceDate}}
          </span>
        </p>
        <p class="m-0 payment text-right align-self-start">{{item?.totalValue || 0 | currency: usd }}</p>
        <p class="m-0 oldPayment text-right align-self-start">{{item?.currentPayment || 0 | currency: usd }}</p>
        <p class="m-0 balanceDue text-right align-self-start">{{item?.oldPayments || 0 | currency: usd }}</p>
        <p class="m-0 balanceDue text-right align-self-start">{{item?.due || 0 | currency: usd }}</p>
      </div>
    </div>

    <div class="s-card-footer">
      <div class=" statement-service">
        <div class="s-card-row flex-start-center">
          <p class="m-0 invCode font-bold pr-2">{{'total'|translate}}</p>
          <p class="m-0 paymentCode font-bold pr-2"></p>
          <p class="m-0 orderName font-bold"></p>
          <p class="m-0 invoiceDate font-bold"></p>
          <p class="m-0 invoiceValue font-bold">{{statementTotal?.total || 0 | currency: usd }}</p>
          <p class="m-0 payment font-bold">{{statementTotal?.currentPayment || 0 | currency: usd }}</p>
          <p class="m-0 oldPayment font-bold">{{statementTotal?.oldPayments || 0 | currency: usd }}</p>
          <p class="m-0 balanceDue font-bold">{{statementTotal?.balanceDue || 0 | currency: usd }}</p>
        </div>
      </div>
    </div>
  </div>
</div>